<template>
<!--Fuente: https://aprende-web.net/NT/anim/anim_3.php-->
  <div>
        
    <div id="visor" >
        <img id="fondoCoche" src="../assets/fondoCoche2.gif" alt="fondoCoche">
        <img id="coche" src="../assets/coche.gif" alt="coche">
    </div>
        

  </div>
</template>

<script>
export default {
    name:'Movement'
}
</script>

<style>
#visor { width: 400px; margin-left: auto; margin-right: auto; height: 350px; background-color: silver;
         overflow: hidden; position: relative; }
#fondoCoche { position: relative; width: 1200px; height: 400px; }
#coche{ position: absolute; top: 250px; left: 140px; width: 200px;  }

@keyframes micoche { 
     from { left: 0px; }
     to { left: -600px; }   
}
@-webkit-keyframes micoche { 
     from { left: 0px; }
     to { left: -600px; }   
}

#fondoCoche {
    animation-name: micoche;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
		
    -webkit-animation-name: micoche;
    -webkit-animation-duration: 3s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;	
    }
</style>